module.exports = window["core-js/modules/es.number.constructor.js"];